<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col class="text-right" cols="12" md="8">
                <v-btn
                @click="showAddDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Add Semester and Schoolyear
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="data"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.semSy="{ item }">
                                <span>{{ item.semester }} - {{ item.schoolyear }}</span>
                            </template>
                            <template v-slot:item.isActive="{ item }">
                                <v-chip v-if="item.isActive == true" size="small" color="green" variant="elevated">
                                    Active
                                </v-chip>
                                <v-chip v-else size="small" color="gray">
                                    Not Active
                                </v-chip>
                            </template>
                            <template v-slot:item.datecreated="{ item }">
                                <span>{{ formatDateTime(item.datecreated)}} </span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <div class="d-flex justify-end ga-2">
                                    <v-btn v-show="item.isActive == false" @click="showConfirmDialog(item)" size="small" variant="outlined" text="Activate" color="green-accent-4" elevation="3"></v-btn>
                                    <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                </div>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <v-dialog v-model="confirmActivate" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want activate this semester and schoolyear?</div>
                <div class="font-weight-light mt-2">Note: If you activate this you will also deactivate the previously active semester and schoolyear</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmActivate = false" :disabled="loadingConfirmation" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loadingConfirmation" @click="activateItem()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <SemesterSchoolyearDialog ref="SemesterSchoolyearDialog" @refresh="init()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import SemesterSchoolyearDialog from '../Dialogs/SemesterSchoolyearDialog.vue';
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    components: {
        SemesterSchoolyearDialog
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            headers: [
                { title: 'Semester and Schoolyear', align: 'start', sortable: true, key: 'semSy' },
                { title: 'Date Created', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'Is Active', align: 'start', sortable: true, key: 'isActive' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            confirmActivate: false,
            loadingConfirmation: false,
            itemToActivate: null,
        }
    },
    methods: {
        init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/semester-schoolyear',
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.data = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        activateItem(){
            const { showSnackbar } = useSnackbar()
            this.loadingConfirmation = true
            const token = localStorage.getItem('aums-token')
            axios.patch(process.env.VUE_APP_SERVER_URL + '/semester-schoolyear/activate', this.itemToActivate,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    this.init()
                    this.loadingConfirmation = false
                    this.confirmActivate = false
                    showSnackbar('Semester and Schoolyear successfully activated')
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showAddDialog(){
            this.$refs.SemesterSchoolyearDialog.initAdd()
        },
        showEditDialog(data){
            this.$refs.SemesterSchoolyearDialog.initUpdate(data)
        },
        showConfirmDialog(data){
            this.itemToActivate = data
            this.confirmActivate = true
        }
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>